export enum ProjectRoleEvents {
    AssignManager = 'assignManager',
    UnassignManager = 'unassignManager',
    EditRoles = 'editRoles'
}
